"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepConnector = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
var util_1 = require("../../util");
var useStepperContext_1 = require("./useStepperContext");
function StepConnector(props) {
    var status = props.status, direction = props.direction, labelHeight = props.labelHeight;
    var gap = useStepperContext_1.useStepperContext().gap;
    var _a = styles_1.useStyles(createStyles, status, gap, labelHeight), classes = _a.classes, css = _a.css;
    return (react_1.default.createElement("span", { "data-testid": 'step-connector', className: css(classes.baseConnector, direction === 'horizontal' ? classes.connectorHorizontal : classes.connectorVertical) }));
}
exports.StepConnector = StepConnector;
var createStyles = function (theme, status, gap, labelHeight) {
    var hasGap = !util_1.isNil(gap);
    var borderStyle = status === 'inactive' ? 'dashed' : 'solid';
    var borderColor = status === 'incompleted' || status === 'inactive' ? theme.pallete.gray.c80 : theme.pallete.primary.main;
    return {
        baseConnector: {
            position: 'absolute',
            transition: 'border-color .4s ease',
        },
        connectorHorizontal: {
            width: hasGap ? "calc(100% + " + gap + "rem - 1rem)" : 'calc(100% - 1rem)',
            top: 'calc(0.75rem - 1px)',
            left: 'calc(50% + 0.5rem)',
            borderTopWidth: '2px',
            borderTopStyle: borderStyle,
            borderTopColor: borderColor,
        },
        connectorVertical: {
            height: hasGap ? "calc(100% + " + gap + "rem - 1rem)" : 'calc(100% - 1rem)',
            top: "calc(" + labelHeight + "px / 2 + 0.5rem)",
            left: 'calc(0.75rem - 1px)',
            borderRightWidth: '2px',
            borderRightStyle: borderStyle,
            borderRightColor: borderColor,
        },
    };
};
//# sourceMappingURL=StepConnector.js.map